import PrivacyPolicyBanner from './PrivacyPolicyBanner';

const GlobalBannerContainer = () => {
  return <PrivacyPolicyBanner />;
};

export default GlobalBannerContainer;
